<script setup lang="ts">
import { computed } from 'vue';
import { HardHat } from 'lucide-vue-next';
import { cn } from '../../design-system/utils';

interface Props {
  /** Si fourni, affiche le logo custom du tenant. Sinon, fallback sur l'icône HardHat. */
  logoSrc?: string;
  /** Texte alt du logo (nom du tenant ou marque) */
  alt?: string;
  size?: 'md' | 'lg';
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  alt: 'Logo',
});

const sizeClasses = {
  md: 'h-10 w-10',  // 40px — taille header standard (musclé vs 36px précédent)
  lg: 'h-12 w-12',  // 48px — pour LoginView, plus prominent
};

const iconSize = computed(() => (props.size === 'lg' ? 22 : 18));

const containerClasses = computed(() =>
  cn(
    'inline-flex items-center justify-center rounded-lg shrink-0',
    'bg-accent text-text-on-accent',
    'shadow-sm',
    sizeClasses[props.size],
  ),
);
</script>

<template>
  <span :class="containerClasses">
    <img
      v-if="logoSrc"
      :src="logoSrc"
      :alt="alt"
      class="h-full w-full object-cover rounded-lg"
      loading="eager"
    />
    <HardHat v-else :size="iconSize" aria-hidden="true" />
  </span>
</template>
